exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-operator[data-v-42423bf6] { margin-bottom: 15px;\n}\n.advert-tip[data-v-42423bf6] { color: #999; font-size: 12px; margin-left: 12px;\n}\n.media-thumb[data-v-42423bf6] { max-height: 48px; max-width: 120px; border-radius: 4px; border: 1px solid #eee;\n}\n", ""]);

// exports
